// src/components/insights/FigureRef.jsx

import { useEffect, useState } from "react";

function FigureRef({ id }) {
  const [number, setNumber] = useState(null);

  useEffect(() => {
    const fig = document.getElementById(`fig-${id}`);
    if (fig) {
      const label = fig.querySelector(".figure-label");
      if (label) {
        const match = label.textContent.match(/\d+/);
        if (match) setNumber(match[0]);
      }
    }
  }, [id]);

  return (
    <a
      href={`#fig-${id}`}
      className="figure-ref"
      onClick={(e) => {
        e.preventDefault();
        document
          .getElementById(`fig-${id}`)
          ?.scrollIntoView({ behavior: "smooth" });
      }}
    >
      Figure {number || "?"}
    </a>
  );
}

export default FigureRef;